import type { PM2ConfigState } from "@pm2/store";
import { configureUserIdentityManager } from "@provider/user-identity";
import { isPlatformNodeJS } from "@utils/common";
import { configRefs } from "@utils/constants";

export function configurePm2UserIdentityManager(configState: PM2ConfigState) {
  if (isPlatformNodeJS()) {
    return;
  }

  configureUserIdentityManager({
    requestLogin: () => {
      const returnUrl = encodeURIComponent(window.location.href);

      const loginUrl =
        `${configRefs.apis.loginConnector.dangerouslyAssertSyncValue()}/Navigator/Navigator` +
        `?clientWebSite=${configState.config.settings.loginProvider}` +
        `&clientWsSuccessUrl=${returnUrl}` +
        `&clientWsFailureUrl=${returnUrl}` +
        `&forceLogin=true`;

      window.location.href = loginUrl;
    },
    logout: () => {
      const returnUrl = encodeURIComponent(window.location.href);

      const logoutUrl = `${configRefs.apis.loginConnector.dangerouslyAssertSyncValue()}/Navigator/Logout?clientWebSite=${configState.config.settings.loginProvider}&logoutSuccessUrl=${returnUrl}`;
      window.location.href = logoutUrl;
    },
  });
}
